"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.THUMBNAIL_SIZE = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
const capture_thumbnail_style_1 = require("../capture.thumbnail/capture.thumbnail.style");
exports.CSS = {
    container: 'c-CaptureBar',
};
exports.THUMBNAIL_SIZE = 100;
exports.Style = {
    [exports.CSS.container]: {
        padding: theme_1.DefaultTheme.space(2),
        display: 'flex',
        'flex-direction': 'column',
        width: exports.THUMBNAIL_SIZE + theme_1.DefaultTheme.spacingFactor * 2,
        'align-items': 'center',
        'overflow-x': 'hidden',
        'overflow-y': 'auto',
        'border-left': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
        'border-right': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
        [`& .${capture_thumbnail_style_1.CSS.container}`]: {
            margin: `${theme_1.DefaultTheme.space(1)} 0`,
            width: `${exports.THUMBNAIL_SIZE}px`,
            height: `${exports.THUMBNAIL_SIZE}px`,
            'min-width': `${exports.THUMBNAIL_SIZE}px`,
            'min-height': `${exports.THUMBNAIL_SIZE}px`,
        },
        [`& .${capture_thumbnail_style_1.CSS.container}:hover`]: {
            border: `${theme_1.DefaultTheme.space(1)} solid ${theme_1.DefaultTheme.color.accent}`,
        },
    },
};
//# sourceMappingURL=capture.bar.style.js.map